export default ({request}) => ({
  masterCategoryMaintainLeftListApi(data = {}) {
    return request({
      url: '/master/masterCategory/leftList',
      method: 'post',
      data,
    })
  },
  masterAccessoriesRightListApi(data = {}) {
    return request({
      url: '/master/masterAccessories/rightList',
      method: 'post',
      data,
    })
  },
  masterAccessoriesSaveApi(data = {}) {
    return request({
      url: '/master/masterAccessories/save',
      method: 'post',
      data,
    })
  },
  masterAccessoriesDetailApi(data = {}) {
    return request({
      url: '/master/masterAccessories/detail',
      method: 'post',
      data,
    })
  },
  masterAccessoriesDelApi(data = {}) {
    return request({
      url: '/master/masterAccessories/del',
      method: 'post',
      data,
    })
  },
})
